import { render, staticRenderFns } from "./Focused.vue?vue&type=template&id=2b2504c0&scoped=true&"
import script from "./Focused.vue?vue&type=script&lang=js&"
export * from "./Focused.vue?vue&type=script&lang=js&"
import style0 from "./Focused.vue?vue&type=style&index=0&id=2b2504c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2504c0",
  null
  
)

export default component.exports